var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"v-required-hint",class:_vm.customClass,attrs:{"role":"alert"}},[_vm._t("default",function(){return [_c('span',{staticClass:"v-required-hint__text"},[_vm._v(_vm._s(_vm.message))])]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }